import type { Theme } from '../../types/theme';

export const xaiTheme: Theme = {
  id: 'xai',
  name: 'xAI',
  description: 'Stark monochrome futuristic minimalism for Elon Musk AI lab',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/x-ai/DESIGN.md',
  visualKeywords: ['monochrome', 'stark', 'futuristic', 'minimal', 'X brand'],
  colors: {
    background: '#000000',
    surface: '#0a0a0a',
    surfaceElevated: '#141414',
    textPrimary: '#ffffff',
    textSecondary: '#888888',
    textMuted: '#888888',
    border: '#1a1a1a',
    borderSubtle: '#242424',
    primary: '#ffffff',
    primaryHover: '#ebebeb',
    primaryActive: '#e1e1e1',
    accent: '#ffffff',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'low',
    tone: 'futuristic',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
